export default "__VITE_ASSET__CxFN7wNP__"